import React from 'react';
import './Pagination.css';

export const PAGE_SIZE_OPTIONS = [25, 50, 100];

/**
 * Rodapé de paginação das grids. `page` começa em 0.
 */
function Pagination({
    page,
    size,
    total,
    onChange,
    disabled = false,
    sizeOptions = PAGE_SIZE_OPTIONS
}) {
    const totalPages = Math.max(1, Math.ceil((total || 0) / size));
    const first = total > 0 ? page * size + 1 : 0;
    const last = Math.min((page + 1) * size, total || 0);

    function goTo(newPage) {
        if (disabled || newPage < 0 || newPage >= totalPages || newPage === page) {
            return;
        }
        onChange(newPage, size);
    }

    function changeSize(event) {
        // Ao trocar a quantidade por página volta para a primeira página
        onChange(0, Number(event.target.value));
    }

    return (
        <div className="pagination-bar">
            <div className="pagination-size">
                <span>Por página</span>
                <select
                    className="combobox pagination-size-select"
                    value={size}
                    onChange={changeSize}
                    disabled={disabled}
                >
                    {sizeOptions.map(option => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select>
            </div>

            <span className="pagination-info">
                {first}–{last} de {total || 0}
            </span>

            <div className="pagination-buttons">
                <button type="button" className="button-field pagination-button" onClick={() => goTo(0)} disabled={disabled || page === 0} title="Primeira página">«</button>
                <button type="button" className="button-field pagination-button" onClick={() => goTo(page - 1)} disabled={disabled || page === 0} title="Página anterior">‹</button>
                <span className="pagination-page">{page + 1} / {totalPages}</span>
                <button type="button" className="button-field pagination-button" onClick={() => goTo(page + 1)} disabled={disabled || page >= totalPages - 1} title="Próxima página">›</button>
                <button type="button" className="button-field pagination-button" onClick={() => goTo(totalPages - 1)} disabled={disabled || page >= totalPages - 1} title="Última página">»</button>
            </div>
        </div>
    );
}

export default Pagination;
